import React from 'react'

import {
    FaMapMarkerAlt
} from 'react-icons/fa'

function Location() {
    return (<
        div className="location-wrapper" >
        <
        div className="adress-wrapper" >
            <
                FaMapMarkerAlt className="location" />
            <
        p className="adress notdesktop" > Průmyslová Zóna < br /> Kostice 777 < br /> 691 52 Kostice < /p> <
        div className="adress desktop" >
                    <
        p > Průmyslová Zóna < /p> <
        p > Kostice 777 < /p> <
        p > 691 52 Kostice < /p> < /
        div > <
        /div>


        <
        div className="mapouter" >
                                    <
        div className="gmap_canvas" >
                                        <
        iframe id="gmap_canvas"
                                            src="https://maps.google.com/maps?q=kostice%20777&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                            frameBorder="0"
                                            scrolling="no"
                                            marginHeight="0"
                                            marginWidth="0" > < /iframe> < /
        div > <
        /div> < /
        div >
    );
}

export default Location



// WEBPACK FOOTER //
// ./src/components/Location.js